import React, { lazy } from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  variant?: 'pink' | 'gold';
}
export function CtaButton({
  children,
  onClick,
  href,
  className = '',
  variant = 'pink'
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (href) {
      if (href.startsWith('#')) {
        const element = document.querySelector(href);
        element?.scrollIntoView({
          behavior: 'smooth'
        });
      } else {
        window.location.href = href;
      }
    } else {
      // Default behavior: scroll to pricing
      const element = document.querySelector('#pricing');
      element?.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  if (variant === 'gold') {
    return <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={handleClick} className={`w-full block drop-shadow-xl rounded-[3.5rem] overflow-hidden ${className}`} data-id="element-112">
        <img src="https://cdn.magicpatterns.com/uploads/5tfjzwYA1vnSuWLtinUTZY/pasted-image.png" alt="¡SI, QUIERO INSCRIBIRME!" loading="lazy" decoding="async" className="w-full h-auto block rounded-[3.5rem] scale-[1.01]" data-id="element-113" />
      </motion.button>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`w-full bg-brand-pinkDark text-white font-display text-xl uppercase tracking-widest py-5 px-8 rounded-full shadow-pink-glow border-b-4 border-black/20 hover:brightness-110 transition-all ${className}`} data-id="element-114">
      {children}
    </motion.button>;
}